export default "__VITE_ASSET__Dp$epXhf__"